module.exports = __webpack_public_path__ + "static/img/pristupnicaispis1.4fc0e26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/pristupnicaispis1.png
// module id = 7ZZN
// module chunks = 0